import styled from "styled-components"

export const Container = styled.div`
`

export const StyledForm = styled.form`
`

export const Message = styled.div`
`